import React from 'react'
import styled, { css } from 'styled-components'
import Link from "next/link"


export const baseCss = css`
font-family: ${props => props.theme.fonts.avenirNextRegular};
color: ${props => props.theme.colors.primary};
cursor: pointer;
text-decoration: none;
&:hover {
  text-decoration: underline;
}
&:focus {
  text-decoration: underline;
}
`

const BasicLink = styled.a`
  ${baseCss}
`

export const NextLink = ({as, href, passHref, ...props}) => {
  return (
    <Link as={as} href={href} passHref={passHref}>
      <BasicLink {...props} />
    </Link>
)
}

export default BasicLink
